import MyTrips from './MyTripsContainer';

export default MyTrips;
